import { ErrorResolutionTypes } from '../../app/common/errorResolution/errorResolution';
import { IAddress } from './address/address.interface';
import { AddressesAction, AddressesActionType } from './addressesActionType';
import { IAddressesState } from './addressesState';

export function addressesReducer(
    state: IAddressesState = {
        addressesMap: {},
        formOpen: false,
        loading: false,
        updatedSuccess: false,
        masterAddress: null,
        stateInputDisabled: true,
    },
    action: AddressesAction,
) {
    let payload: any;
    let addressesMap: { [addressUuid: string]: IAddress } = {};

    switch (action.type) {
        case AddressesActionType.ADD_ADDRESS_REQUEST:
        case AddressesActionType.GET_ADDRESSES_REQUEST:
        case AddressesActionType.REMOVE_ADDRESS_REQUEST:
        case AddressesActionType.UPDATE_ADDRESS_REQUEST:
        case AddressesActionType.GET_MASTER_ADDRESS_REQUEST:
            payload = action.payload;
            return {
                ...state,
                loading: true,
            };

        case AddressesActionType.ADD_ADDRESS_FAILURE:
        case AddressesActionType.GET_ADDRESSES_FAILURE:
        case AddressesActionType.REMOVE_ADDRESS_FAILURE:
        case AddressesActionType.UPDATE_ADDRESS_FAILURE:
            payload = action.payload;
            const formOpenNewState =
                payload.errorResolution &&
                payload.errorResolution.type !== ErrorResolutionTypes.REDIRECTING
                    ? state.formOpen
                    : false;
            return {
                ...state,
                formOpen: formOpenNewState,
                loading: false,
                updatedSuccess: false,
            };

        case AddressesActionType.ADD_ADDRESS_SUCCESS:
        case AddressesActionType.UPDATE_ADDRESS_SUCCESS:
            payload = action.payload;
            addressesMap = { ...state.addressesMap };
            addressesMap[payload.address.addressUuid] = payload.address;
            return {
                ...state,
                addressesMap,
                formOpen: false,
                loading: false,
                updatedSuccess: true,
            };

        case AddressesActionType.GET_ADDRESSES_SUCCESS:
            payload = action.payload;
            addressesMap = {};
            payload.addresses.map(
                (address: IAddress) => (addressesMap[address.addressUuid] = address),
            );
            return {
                ...state,
                addressesMap,
                loading: false,
            };

        case AddressesActionType.REMOVE_ADDRESS_SUCCESS:
            payload = action.payload;
            addressesMap = { ...state.addressesMap };
            delete addressesMap[payload.addressUuid];
            return {
                ...state,
                addressesMap,
                loading: false,
            };

        case AddressesActionType.SET_DEFAULT_SHIPPING:
            payload = action.payload;
            addressesMap = { ...state.addressesMap };
            if (typeof payload.isShipping === 'boolean') {
                Object.keys(addressesMap).forEach((addressUuid: string) => {
                    addressesMap[addressUuid].isShipping =
                        addressUuid === payload.addressUuid ? Boolean(payload.isShipping) : false;
                });
            }
            return {
                ...state,
                addressesMap,
            };

        case AddressesActionType.OPEN_ADDRESS_FORM:
            return {
                ...state,
                formOpen: true,
            };

        case AddressesActionType.CLOSE_ADDRESS_FORM:
            return {
                ...state,
                formOpen: false,
            };

        case AddressesActionType.SET_MASTER_ADDRESS_REQUEST:
            payload = action.payload;
            return {
                ...state,
                loading: false,
                masterAddress: payload.masterAddress,
            };
        case AddressesActionType.HIDDEN_ADDRESSES_UPDATED_INFO:
            return {
                ...state,
                updatedSuccess: false,
            };
        case AddressesActionType.CHANGE_STATE_INPUT_DISABLED:
            return {
                ...state,
                stateInputDisabled: action.payload,
            };
        default:
            return state;
    }
}
